export default __webpack_public_path__ + "static/media/desktop-preview.deeed775.jpg";